// @ts-nocheck

import { createBrowserRouter, Navigate, Outlet, useNavigate } from "react-router-dom";
import { Login } from "../pages/Login";
import { Home } from "../pages/Home";
import { MainLayout } from "../layout/MainLayout";
import { TrackingByCostCenter } from "../pages/Frota/TrackingByCostCenter";
import Analytics from "../pages/TimTOA/Indicators";
import { MapActivities } from "../pages/TimTOA/MapActivities";
import { ViewTasks } from "../pages/TimTOA/ViewTasks";
import Indicators from "../pages/TimTOA/Indicators";
import FleetTrack from "../pages/TimTOA/FleetTrack";
import { ConsumoKmPorLitro } from "../pages/Frota/ConsumoKmPorLitro";
import { Users } from "../pages/UserManagement/Users";
import useStore from "../store/useStore";
import { useEffect } from "react";
import { PontoResidencia } from "../pages/RH/PontoResidencia";
import { PainelFrota } from "../pages/Frota/PainelFrota";
import { RegisterVehicle } from "../pages/Frota/RegisterVehicle";
import { TableFleet } from "../pages/Frota/TableFleet";
import { MaintenanceFleet } from "../pages/Frota/MaintenanceFleet";
import { Workshops } from "../pages/Frota/Workshops";

const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("@tlp-authToken");
  const { user } = useStore((state) => state);
  const navigate = useNavigate();

  useEffect(() => {
    // Se for primeiro acesso e não estiver na home, redireciona para home
    const userData = JSON.parse(localStorage.getItem("@tlp-user") || "{}");
    if (userData.firstAccess && window.location.pathname !== "/home") {
      navigate("/home");
    }
  }, [navigate]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles) {
    return <Outlet />;
  }

  const hasRequiredRole = user.role.some((userRole) => allowedRoles.includes(userRole));

  if (!hasRequiredRole) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    // Proteção global para todas as rotas autenticadas
    element: <ProtectedRoute allowedRoles={null} />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: "/home",
            element: <Home />,
          },
          {
            element: <ProtectedRoute allowedRoles={["admin"]} />,
            children: [
              {
                path: "/user-management",
                element: <Users />,
              },
            ],
          },
          {
            element: <ProtectedRoute allowedRoles={["admin", "rh"]} />,
            children: [
              {
                path: "/ponto-residencia",
                element: <PontoResidencia />,
              },
            ],
          },
          {
            element: <ProtectedRoute allowedRoles={["admin", "fleet_manager"]} />,
            children: [
              {
                path: "/painel-frota",
                element: <PainelFrota />,
              },
              {
                path: "/register-vehicle",
                element: <RegisterVehicle />,
              },
              {
                path: "/table-fleet",
                element: <TableFleet />,
              },
              {
                path: "/maintenance-fleet",
                element: <MaintenanceFleet />,
              },
              {
                path: "/workshops",
                element: <Workshops />,
              },
              {
                path: "/rastreio-centro-custo",
                element: <TrackingByCostCenter />,
              },
              {
                path: "/consumo-km-litro",
                element: <ConsumoKmPorLitro />,
              },
            ],
          },
          {
            element: <ProtectedRoute allowedRoles={["admin", "tim_toa"]} />,
            children: [
              {
                path: "/view-tasks",
                element: <ViewTasks />,
              },
              {
                path: "/map-activities",
                element: <MapActivities />,
              },
              {
                path: "/indicators",
                element: <Indicators />,
              },
              {
                path: "/fleettrack",
                element: <FleetTrack />,
              },
            ],
          },
        ],
      },
    ],
  },
  // Rota para capturar URLs não definidas
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
]);
